import React, { FC } from 'react';

import { ProjectBehaviorStrategy } from '~/projects/ProjectBehaviorStrategy';

const ThemeToggle = ProjectBehaviorStrategy.shouldLoadDesktopSidebarThemeToggle
  ? require('~/projects/polyllm-chat/components/ThemeToggle').default
  : null;

const ThemeToggleLoader: FC = () => {
  if (!ThemeToggle) return null;
  return <ThemeToggle />;
};

export default ThemeToggleLoader;
